import { useRouteMatch } from "react-router-dom";
import { useNacLocation } from "../../../../hooks/useNacLocation";
import { matchRoute } from "../../../../routes";
import { useSelector } from "react-redux";

export const useOopsMessage = () => {
    const nicheItems = useSelector((state) => state.pages.nicheItems);
    const styling = useSelector((state) => state.root.styling);
    const states = styling?.states;
    const { pathname } = useNacLocation();
    const pageType = matchRoute(pathname);
    const match = useRouteMatch({
        path: "/:state?/:niche?/:three?/:community?",
    });
    const { state, niche } = match.params;

    let partOne = "",
        partTwo = "",
        href = undefined,
        linkText = "";
    if (pageType === "agent") {
        partOne = "We can’t seem to find that agent. Visit our ";
        partTwo = " page to connect with another one of our agents.";
        href = "/agents";
        linkText = "Find an Agent";
    } else if (pageType === "nicheItem" && Object.keys(states).length > 0) {
        const path = `/${state}`;
        const { stateName } =
            Object.values(states).find((state) => state.valueLink === path) ||
            {};
        partOne = "We can’t seem to find that market. Visit our ";
        partTwo = " page to find other listings in that state.";
        href = path;
        linkText = stateName;
    } else if (pageType === "listing" && Object.keys(nicheItems).length > 0) {
        const path = `/${state}/${niche}`;
        const { displayName } =
            Object.values(nicheItems).find(
                (nicheItem) => `/${nicheItem.urlPath}` === path
            ) || {};
        partOne = "We can’t seem to find that listing. Visit our ";
        partTwo = " page to find other listings in that market.";
        href = path;
        linkText = displayName;
    } else if (
        pageType === "nicheItem_development" &&
        Object.keys(nicheItems).length > 0
    ) {
        const path = `/${state}/${niche}`;
        const { displayName } =
            Object.values(nicheItems).find(
                (nicheItem) => `/${nicheItem.urlPath}` === path
            ) || {};
        partOne = "We can’t seem to find that community. Visit our ";
        partTwo = " page to find other communities in that market.";
        href = `${path}#communities`;
        linkText = displayName;
    } else {
        partOne =
            "We can't seem to find that page. Can we help you with your search?";
    }

    return {
        partOne,
        partTwo,
        href,
        linkText,
    };
};
